import Image from "../Article/Image";
import ArrowLeft from "!!raw-loader!../../assets/icons/arrow-left.svg";
import ArrowRight from "!!raw-loader!../../assets/icons/arrow-right.svg";
import CloseButton from "!!raw-loader!../../assets/icons/close-button.svg";
import { useEffect } from "react";

export default function ImageDetailView({ image, caption, onClose, onNext, onPrevious }) {
  const initEscListener = () => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  };

  useEffect(initEscListener, []);

  return (
    <div
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center py-20 px-8"
      style={{ background: "rgba(0, 0,0, 0.8)", zIndex: "600" }}
    >
      <div
        dangerouslySetInnerHTML={{ __html: ArrowLeft }}
        className="arrow-icon fixed left-0 ml-10 2xl:ml-20 cursor-pointer"
        onClick={onPrevious}
      />
      <Image src={image.url} alt={image.alt} caption={image.caption} preset="article" />
      <div
        dangerouslySetInnerHTML={{ __html: ArrowRight }}
        className="arrow-icon fixed right-0 mr-10 2xl:mr-20 cursor-pointer"
        onClick={onNext}
      />
      <div
        dangerouslySetInnerHTML={{ __html: CloseButton }}
        className="icon fixed right-0 top-0 w-10 mr-10 2xl:mr-20 mt-20 text-white cursor-pointer"
        onClick={onClose}
      />
    </div>
  );
}
